import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

const Layout = () => (
  <div className="min-h-screen bg-white text-zinc-900 flex flex-col">
    <Navbar />
    <main className="flex-1 pt-28">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default Layout;
